export default __webpack_public_path__ + "img/bid-board.a8d733.svg";